import * as requests from './requests';

export default {
    requests,
};
